// Performance monitoring utilities for counter widget

// Monitor counter widget loading time
export const monitorCounterWidgetPerformance = () => {
  // if ('performance' in window) {
  //   // Mark when counter widget starts loading
  //   performance.mark('counter-widget-start');
    
  //   // Observer for when counter widget is rendered
  //   const observer = new MutationObserver((mutations) => {
  //     mutations.forEach((mutation) => {
  //       if (mutation.type === 'childList') {
  //         const counterWidget = document.querySelector('.bs-counter-widget');
  //         if (counterWidget && !counterWidget.classList.contains('bs-counter-widget--loading')) {
  //           performance.mark('counter-widget-end');
  //           performance.measure('counter-widget-load-time', 'counter-widget-start', 'counter-widget-end');
            
  //           const measure = performance.getEntriesByName('counter-widget-load-time')[0];
  //           console.log(`Counter widget loaded in ${measure.duration.toFixed(2)}ms`);
            
  //           observer.disconnect();
  //         }
  //       }
  //     });
  //   });
    
  //   observer.observe(document.body, {
  //     childList: true,
  //     subtree: true
  //   });
  // }
};

// Monitor API call frequency
let apiCallCount = 0;
let lastApiCall = 0;

export const monitorCartApiCalls = () => {
  // const originalFetch = window.fetch;
  
  // window.fetch = function(...args) {
  //   const url = args[0];
    
  //   if (typeof url === 'string' && url.includes('/cart')) {
  //     apiCallCount++;
  //     const now = Date.now();
  //     const timeSinceLastCall = now - lastApiCall;
      
  //     console.log(`Cart API call #${apiCallCount}, ${timeSinceLastCall}ms since last call`);
  //     lastApiCall = now;
  //   }
    
  //   return originalFetch.apply(this, args);
  // };
};

// Monitor layout shifts
export const monitorLayoutShifts = () => {
  // if ('PerformanceObserver' in window) {
  //   const observer = new PerformanceObserver((list) => {
  //     for (const entry of list.getEntries()) {
  //       if (entry.hadRecentInput) continue;
        
  //       console.log('Layout shift detected:', {
  //         value: entry.value,
  //         sources: entry.sources?.map(source => ({
  //           node: source.node,
  //           currentRect: source.currentRect,
  //           previousRect: source.previousRect
  //         }))
  //       });
  //     }
  //   });
    
  //   observer.observe({ entryTypes: ['layout-shift'] });
  // }
};

// Initialize all performance monitoring
export const initPerformanceMonitoring = () => {
  // if (process.env.NODE_ENV === 'development') {
  //   monitorCounterWidgetPerformance();
  //   monitorCartApiCalls();
  //   monitorLayoutShifts();
    
  //   console.log('Performance monitoring initialized for counter widget');
  // }
};